import { render, staticRenderFns } from "./HistoryModal.vue?vue&type=template&id=67e06d23"
import script from "./HistoryModal.vue?vue&type=script&lang=js"
export * from "./HistoryModal.vue?vue&type=script&lang=js"
import style0 from "./HistoryModal.vue?vue&type=style&index=0&id=67e06d23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports